"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0B1C2D]">
      {}
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl text-foreground mb-6 leading-tight">
          Practice Growth Stalls When the Wrong Problem Is Fixed
        </h1>

        {}
        <p className="font-sans text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed !text-3xl">Diagnosis Comes Before Execution</p>

        {}
        <Link to="#contact">
          <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs h-10 rounded-md has-[>svg]:px-4 btn-primary text-base px-8 py-4 shadow-medium !bg-[hsl(29,100%,50%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 md:text-lg">Book the Practice Growth Diagnostic</Button>
        </Link>
      </div>
    </section>;
}